import { render, staticRenderFns } from "./TeamSeatsInput.vue?vue&type=template&id=d8dd84d6"
import script from "./TeamSeatsInput.vue?vue&type=script&lang=js"
export * from "./TeamSeatsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeamSeatsInput.vue"
export default component.exports